import { CustomSuccessToast } from '@shared/components/customSuccessToast';
import { CallDto } from '@shared/services/apiService/apiService';
import { t } from 'i18next';
import { toast } from 'react-toastify';

export const getCampaignWebhookErrorMessage = (error: unknown, fallbackKey: string): string => {
  if (error && typeof error === 'object') {
    const data = 'data' in error ? (error as { data?: unknown }).data : undefined;

    if (typeof data === 'string') {
      return data;
    }

    if (data && typeof data === 'object') {
      const message = (data as { message?: unknown }).message;

      if (typeof message === 'string') {
        return message;
      }

      if (Array.isArray(message) && typeof message[0] === 'string') {
        return message[0];
      }
    }
  }

  return t(fallbackKey);
};

export const showCampaignWebhookSuccessToast = (description: string) => {
  toast.success(CustomSuccessToast, {
    closeButton: false,
    autoClose: 5000,
    icon: false,
    data: {
      title: t('common.success'),
      description,
    },
  });
};

export const formatCampaignWebhookCallLabel = (call: CallDto): string => {
  const customerLabel = call.customer?.number || call.customer?.name || call.name || call.id;
  const endedAt = call.endedAt
    ? new Date(call.endedAt).toLocaleString()
    : new Date(call.createdAt).toLocaleString();
  const endedReason = call.endedReason || t('common.na');

  return `${customerLabel} • ${endedAt} • ${endedReason}`;
};
